import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import LoginIcon from '@mui/icons-material/Login';
import RefreshIcon from '@mui/icons-material/Refresh';
import { Alert, AlertTitle, Box, Button } from '@mui/material';
import { defineMessage, FormattedMessage } from 'react-intl';
import { MessageScreen } from '../../components/error/MessageScreen';

const fatalErrorRefreshMessage = defineMessage({
  id: 'common.fatalError.refreshBtn',
  defaultMessage: 'Refrescar',
});

const fatalErrorLoginAgainMessage = defineMessage({
  id: 'common.fatalError.loginAgainBtn',
  defaultMessage: 'Iniciar sesión nuevamente',
});

/** Reloads the current page; used instead of Router navigation outside ErrorBoundary. */
function handleFatalErrorRefresh() {
  window.location.reload();
}

export function FatalError() {
  return (
    <Box>
      {' '}
      {/* Box to prevent flex height 100% */}
      <Alert severity="error" icon={<ErrorOutlineIcon />} sx={{ p: 4, mt: 5, mx: 'auto' }}>
        <AlertTitle>
          <FormattedMessage id="common.fatalError.title" defaultMessage="Ha ocurrido un error" />
        </AlertTitle>
        <Box sx={{ mt: 3 }}>
          <FormattedMessage
            id="common.fatalError.body"
            defaultMessage="Refresca la página o vuelve a iniciar sesión.{br}Si el problema persiste, contactate con nosotros."
            values={{
              br: <br />,
            }}
          />
        </Box>
        <Box
          sx={{
            mt: 3,
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            gap: 2,
          }}
        >
          <Button
            variant="outlined"
            color="secondary"
            startIcon={<RefreshIcon />}
            onClick={handleFatalErrorRefresh}
          >
            <FormattedMessage {...fatalErrorRefreshMessage} />
          </Button>
          {/* Native anchor: FatalError renders outside Router (e.g. Bugsnag ErrorBoundary). */}
          <Button
            component="a"
            href="/logout"
            variant="outlined"
            color="primary"
            startIcon={<LoginIcon />}
          >
            <FormattedMessage {...fatalErrorLoginAgainMessage} />
          </Button>
        </Box>
      </Alert>
    </Box>
  );
}

export function FatalErrorScreen() {
  return (
    <MessageScreen>
      <FatalError />
    </MessageScreen>
  );
}
